import { hydrateRoot } from "react-dom/client";
import App from "../app";

const container = document.getElementById("react-root");
const data = window.asos.sitemap.data;
const defaultLanguage = window.asos.webContext.getBrowseLanguage();

hydrateRoot(container, <App data={data} defaultLanguage={defaultLanguage} />);
